import {
  COMPLETE_FIBSD_IN_PROGRESS,
  COMPLETE_FIBSD_SUCCESS,
  COMPLETE_FIBSD_FAIL,
} from "../constants";

const initialState = {
  saving: false,
  saved: false,
  errors: null,
};

/**
 * Complete FIBSD reducer
 *
 * @param {Object} state
 * @param {Object} action
 *
 * @return {Object}
 */
export default function completeFibsd(state = initialState, action) {
  const { type } = action;

  switch (type) {
    case COMPLETE_FIBSD_IN_PROGRESS:
      return {
        ...state,
        saving: true,
        saved: false,
        errors: null,
      };

    case COMPLETE_FIBSD_SUCCESS:
      return {
        ...state,
        saving: false,
        saved: true,
      };

    case COMPLETE_FIBSD_FAIL:
      return {
        ...state,
        saving: false,
        saved: false,
        errors: true,
      };

    default:
      return state;
  }
}
